module.exports = __webpack_public_path__ + "img/EXTERIOR-IGNIS-3.ceead8a2.png";